export var QueueWaitOfferType;
(function (QueueWaitOfferType) {
    QueueWaitOfferType[QueueWaitOfferType["CALLBACK"] = 0] = "CALLBACK";
    QueueWaitOfferType[QueueWaitOfferType["TRANSFER_QUEUE"] = 1] = "TRANSFER_QUEUE";
    QueueWaitOfferType[QueueWaitOfferType["VOICE_MAIL"] = 2] = "VOICE_MAIL";
})(QueueWaitOfferType || (QueueWaitOfferType = {}));
//# sourceMappingURL=queue-wait-offer-type.enum.js.map